import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import metadataAll from '../data/metaData_AllPages_v1.json';

export const useMetadata = (language = 'ar') => {
    const location = useLocation();

    const setMetadata = (metadata) => {
        if (!metadata) return;

        // Set basic meta tags based on language
        document.title = metadata[language]?.title || metadata['ar']?.title || '';

        // Update description with language fallback
        const descriptionTag = document.querySelector('meta[name="description"]');
        if (descriptionTag) {
            descriptionTag.setAttribute('content',
                metadata[language]?.description ||
                metadata['ar']?.description ||
                ''
            );
        }

        // Update SEO meta tags if they exist
        if (metadata.seo) {
            // Set canonical with proper language path
            let canonicalTag = document.querySelector('link[rel="canonical"]');
            if (!canonicalTag) {
                canonicalTag = document.createElement('link');
                canonicalTag.rel = 'canonical';
                document.head.appendChild(canonicalTag);
            }
            const baseUrl = metadata.url.split('/ar')[0];
            canonicalTag.href = `${baseUrl}/${language}${location.pathname}`;

            // Set keywords with language support
            let keywordsTag = document.querySelector('meta[name="keywords"]');
            if (!keywordsTag) {
                keywordsTag = document.createElement('meta');
                keywordsTag.name = 'keywords';
                document.head.appendChild(keywordsTag);
            }
            keywordsTag.content = metadata.seo.meta?.name?.keywords || '';

            // Add language alternates
            const alternateAr = document.querySelector('link[hreflang="ar"]');
            const alternateEn = document.querySelector('link[hreflang="en"]');

            if (!alternateAr) {
                const arLink = document.createElement('link');
                arLink.rel = 'alternate';
                arLink.hreflang = 'ar';
                arLink.href = `${baseUrl}/ar${location.pathname}`;
                document.head.appendChild(arLink);
            }

            if (!alternateEn) {
                const enLink = document.createElement('link');
                enLink.rel = 'alternate';
                enLink.hreflang = 'en';
                enLink.href = `${baseUrl}/en${location.pathname}`;
                document.head.appendChild(enLink);
            }
        }
    };

    useEffect(() => {
        const currentPath = location.pathname;
        // Remove language prefix for path matching
        const pathWithoutLang = currentPath.replace(/^\/(ar|en)/, '');
        const normalizedPath = pathWithoutLang.endsWith('/')
            ? pathWithoutLang.slice(0, -1)
            : pathWithoutLang;

        // Find matching metadata
        const metadata = metadataAll.find(meta => {
            const metaPath = new URL(meta.url).pathname.replace(/^\/(ar|en)/, '');
            return metaPath === normalizedPath;
        });

        if (metadata) {
            setMetadata(metadata);
        }
    }, [location, language]);
};